// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 12C1 10.067 2.567 8.5 4.5 8.5C6.08551 8.5 7.42479 9.55426 7.85506 11H8.64494C9.07521 9.55426 10.4145 8.5 12 8.5C13.5855 8.5 14.9248 9.55426 15.3551 11H16.1449C16.5752 9.55426 17.9145 8.5 19.5 8.5C21.433 8.5 23 10.067 23 12C23 13.933 21.433 15.5 19.5 15.5C17.9145 15.5 16.5752 14.4457 16.1449 13H15.3551C14.9248 14.4457 13.5855 15.5 12 15.5C10.4145 15.5 9.07521 14.4457 8.64494 13H7.85506C7.42479 14.4457 6.08551 15.5 4.5 15.5C2.567 15.5 1 13.933 1 12Z"}}]};

const ComponentStepsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-steps-filled',
    ref,
    icon: element,
  },
));

ComponentStepsFilledIcon.displayName = 'ComponentStepsFilledIcon';

export default ComponentStepsFilledIcon;
